import script from "./VitaTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./VitaTooltip.vue?vue&type=style&index=0&id=40a5fec2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a5fec2"]])

export default __exports__